/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */
import React, { useState } from 'react';
import {
    object, func, bool,
} from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ReactHtmlParser from 'react-html-parser';
import Grid from '@material-ui/core/Grid';
import { Button } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import IconButton from '@material-ui/core/IconButton';
import { useDispatch, useSelector } from 'react-redux';
import AddonModal from './AddonModal';
import { getSelectedInlineAddons } from '../../../../../../../state/ducks/App/App-Selectors';
import { trackEvent } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const styles = (theme) => ({
    imageContainer: {
        textAlign: 'center',
    },
    imageWine: {
        width: 'auto',
        height: '91px',
        display: 'flex',
        margin: '0px auto 5px',
    },
    addonsName: {
        fontSize: '0.75rem',
        fontWeight: '400',
        fontFamily: theme.typography.fontFamily,
        overflow: 'hidden',
        display: '-webkit-box',
        ' -webkit-line-clamp': 2,
        '-webkit-box-orient': 'vertical',
        textOverflow: 'ellipsis',
        cursor: 'pointer',
        textDecoration: 'underline',
        minHeight: '34px',
    },
    addonsMobile: {
        fontSize: '0.813rem',
        fontWeight: '400',
        fontFamily: theme.typography.fontFamily,
    },
    inputlabel: {
        color: theme.palette.white,
        fontSize: '1.25rem',
        fontWeight: '400',
        fontFamily: theme.typography.fontFamily,
        padding: '0px 0px 0px 0.5rem',
    },
    addonsMobileSection: {
        '& > .MuiListItem-gutters': {
            paddingLeft: 0,
            paddingRight: 0,
        },
    },
    listItem: {
        boxShadow: '0px 0px 5px rgba(47, 47, 47, 0.25)',
        marginRight: '0.625rem',
        padding: '0.438rem',
        '&:hover': {
            boxShadow: '0px 0px 0px 2px rgb(44 128 19)',
        },
        '@media screen and (max-width: 1024px)': {
            marginRight: 0,
        },
    },
    buttonContinue: {
        background: theme.palette?.primary?.main || '#2F2F2F',
        width: '100%',
        fontSize: '1rem',
        lineHeight: '20px',
        color: theme.palette.cms?.white || '#ffffff',
        marginTop: '0.5rem',
        borderRadius: 'inherit',
        textTransform: 'capitalize',
        padding: '0.125rem',
        fontWeight: '700',
        '&:hover': {
            background: theme.palette?.primary?.main || '#2F2F2F',
        },
        '& svg': {
            display: 'flex',
            width: '0.7em',
            alignItems: 'center',
            marginLeft: '0.313rem',
        },
    },
    addPrice: {
        fontSize: '0.875rem',
        lineHeight: '1.125rem',
        display: 'block',
        fontWeight: '700',
    },

    delButtonContainer: {
        background: theme.palette.cms?.lightGreen || '#3f8d5c',
        width: '100%',
        color: theme.palette.cms?.white || '#ffffff',
        borderRadius: 0,
        marginTop: '0.5rem',
        padding: '0.375rem',
        '&:hover': {
            background: theme.palette.cms?.lightGreen || '#3f8d5c',
        },
    },
    delButton: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        height: 20,
        '& .MuiIconButton-root': {
            '&:hover': {
                backgroundColor: 'transparent',
            },
        },
        '& img': {
            width: '20px',
            height: '20px',
        },
    },
    deleteIcon: {
        width: '23px',
        height: '23px',
        padding: '0px 12px',
        '&:focus': {
            outline: 'inherit',
        },
    },
    addIcon: {
        display: 'flex',
        alignItems: 'center',
        '& svg': {
            width: '0.8em',
            display: 'block',
        },
    },
    addOnCount: {
        fontSize: '1.25rem',
    },
    hoverEffectColor: {
        boxShadow: '0px 0px 0px 2px rgb(44 128 19)',
    },
    addOnListWrapper: {
        '& $listItem': {
            boxShadow: 'none',
            marginRight: '0',
            padding: '0',
            '&:hover': {
                boxShadow: 'none',
            },
            '@media screen and (max-width: 1024px)': {
                marginRight: 0,
            },
        },
        '& $buttonContinue': {
            border: '1px solid #000000',
            fontSize: '14px',
            color: '#000000',
            lineHeight: '20px',
            padding: '5px 0px',
            margin: '12px 0px 0px',
            background: '#ffffff',
            '&:hover': {
                background: '#ffffff',
            },
            '& svg': {
                width: '0.5em',
                height: '0.5em',
                marginLeft: '0px',
            },
        },
        '& $delButtonContainer': {
            marginTop: '12px',
        },
        '& $addonsName': {
            fontSize: '14px',
            lineHeight: '22px',
            marginTop: '8px',
            [theme.breakpoints.down('600')]: {
                fontSize: '12px',
            },
        },

    },
});

const getPrice = (item, type = 'sale') => {
    let priceList = (item?.prices || []).filter((price) => price.type === type) || [];
    if (priceList.length > 0) {
        priceList = priceList[0];
        return priceList?.value;
    }
    return 0;
};

const AddonItemsListV3 =  (
    {
        classes,
        options,
        handleCount,
        error,
        handleDecrement,
        handleIncrement,
        isPdpRedesignEnabled,
    },

) => {
    const dispatch = useDispatch();
    // buildImgPath is using 2x dimension request to improve image clarity.
    const buildImgPath = (path, name) => `${path + name}t.jpg?height=182&auto=webp`;
    const selectAddons = useSelector(getSelectedInlineAddons);
    const [open, setOpen] = useState(false);
    const matchAddons = (addOnId) => selectAddons?.some((item) => item?.id === addOnId);
    const [selectedOption, setSelectedOption] = useState({});
    const handlePopup = (item) => {
        setSelectedOption(item);
        setOpen(true);
    };
    return (
        <div className={`${classes.addOnListContainer} ${isPdpRedesignEnabled ? classes.addOnListWrapper : ''}`}>

            <div
                className={matchAddons(options?.id) ? `${classes.listItem} ${classes.hoverEffectColor}` : classes.listItem}
            >
                <Grid item sm={12} xs={12} className={classes.imageContainer}>
                    <img className={classes.imageWine} src={buildImgPath(options?.image?.path, options?.image?.name)} alt={options?.name || 'addOns'} width="79" height="88" />
                </Grid>
                <Grid item sm={12} xs={12}>
                    <Typography
                        component="span"
                        variant="body2"
                        color="textPrimary"
                        className={classes.addonsName}
                        onKeyDown={() => {}}
                        tabIndex={-1}
                        role="button"
                        onClick={() => {
                            handlePopup(options);
                        }}
                    >
                        {ReactHtmlParser(options?.name)}
                    </Typography>
                    <Typography
                        component="span"
                        variant="body2"
                        className={classes.addPrice}
                        color="textPrimary"
                    >
                        {!isPdpRedesignEnabled && `$${getPrice(options)}`}
                    </Typography>
                    {!matchAddons(options?.id) ?  (
                        <Button
                            color="primary"
                            id={` Add ${options?.name || 'Item'} to cart`}
                            data-testid="btn-add"
                            className={`${classes.buttonContinue} `}
                            onKeyDown={() => {}}
                            tabIndex={-1}
                            role="button"
                            onClick={() => {
                                handleIncrement(options);
                                dispatch(trackEvent({
                                    eventCategory: 'Inline Addons',
                                    eventAction: 'Added Item',
                                    eventLabel: options?.id || '',
                                }));
                            }}
                        >
                            Add  <AddIcon />{isPdpRedesignEnabled && `$${getPrice(options)}`}
                        </Button>
                    ) : (
                        <Button
                            color="primary"
                            id={` Remove ${options?.name || 'Item'} from cart`}
                            data-testid="btn-remove"
                            className={`${classes.delButtonContainer} `}
                            tabIndex={-1}
                        >
                            <span className={classes.delButton}>
                                <IconButton
                                    className={classes.deleteIcon}
                                    onClick={() => {
                                        handleDecrement(options);
                                        dispatch(trackEvent({
                                            eventCategory: 'Inline Addons',
                                            eventAction: 'Removed Item',
                                            eventLabel: options?.id || '',
                                        }));
                                    }}
                                    onKeyDown={() => {}}
                                    tabIndex={-1}
                                    role="button"
                                >
                                    <img src="https://images.contentstack.io/v3/assets/blt89dbf1c763ec00a6/blt8803188c991cd120/632ae23d8966566ecdfbe08e/delete.svg?auto=webp" alt="Remove Logo" />
                                </IconButton>
                                <span className={classes.addOnCount}>{handleCount(options)}</span>
                                <span
                                    className={classes.addIcon}
                                    onKeyDown={() => {}}
                                    tabIndex={-1}
                                    role="button"
                                    onClick={() => {
                                        handleIncrement(options);
                                        dispatch(trackEvent({
                                            eventCategory: 'Inline Addons',
                                            eventAction: 'Added Item',
                                            eventLabel: options?.id || '',
                                        }));
                                    }}
                                > <AddIcon />
                                </span>
                            </span>
                        </Button>
                    ) }
                </Grid>
                {open && <AddonModal selectedOption={selectedOption} matchAddons={matchAddons} open={open} setOpen={setOpen} handleIncrement={handleIncrement} handleDecrement={handleDecrement} handleQuantity={handleCount} error={error} isPdpRedesignEnabled={isPdpRedesignEnabled} />}
            </div>
        </div>
    );
};

AddonItemsListV3.propTypes = {
    handleCount: func,
    classes: object.isRequired,
    options: object,
    handleDecrement: func,
    handleIncrement: func,
    error: bool,
    isPdpRedesignEnabled: bool,
};
AddonItemsListV3.defaultProps = {
    options: {},
    handleCount: () => {},
    handleDecrement: () => {},
    handleIncrement: () => {},
    error: false,
    isPdpRedesignEnabled: false,
};

export default (withStyles(styles)(AddonItemsListV3));
